<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox">
          <div class="ibox-title">
            <h5><i class="fa fa-user"></i>&nbsp;Propriétaire actuel</h5>
          </div>
          <div class="ibox-content">
            <div class="owner-wizard">
              <ul class="steps">
                <li v-for="(step, index) in steps"
                    :key="index"
                    :class="[index + 1 === activeStep ? 'active' : 'allowed']"
                    @click="toggleBlock(index + 1)">{{ index + 1 }}. {{ step }}</li>
              </ul>
              <keep-alive v-if="activeStep !== 3">
                <component v-if="ownerInformation"
                           :is="component"
                           :owner-information="ownerInformation"
                           :command="command"
                           :seller="seller"/>
              </keep-alive>
              <component v-else-if="ownerInformation"
                         :is="component"
                         :owner-information="ownerInformation"
                         :command="command"
                         :seller="seller"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import gql from 'graphql-tag'
  import Identite from '../../components/details/proprietaire/Identite'
  import Qualification from '../../components/details/proprietaire/Qualification'
  import Documents from '../../components/details/proprietaire/Documents'

  export default {
    props: {
      command: {
        type: Object,
        required: true
      }
    },

    components: {
      'identite': Identite,
      'qualification': Qualification,
      'documents': Documents,
    },

    data: () => ({
      blocks: [
        'identite',
        'qualification',
        'documents'
      ],
      steps: [
        'Identité',
        'Questions de qualification',
        'Documents'
      ],
      activeStep: 1,
      ownerInformation: null
    }),

    computed: {
      component () {
        return this.blocks[this.activeStep - 1]
      },

      commandId () {
        return this.$route.params.id
      },

      seller () {
        return this.command.seller[0]
      },

      ownerInformationQuery () {
        return gql`
        query{
          ownerInformation(orderId: "${this.commandId}") {
            owners {
              hasCoOwner
              isSellerOwner
              isSellerCoOwner
              owner{
                civility
                firstName
                lastName
                usedName
                ownerType
                companyName
                siretNumber
                address {
                  address
                  city
                  zipCode
                }
                documentId
              }
              coOwner {
                civility
                firstName
                lastName
                usedName
                address {
                  address
                  city
                  zipCode
                }
                documentId
              }
            }
            ownerQuestions {
              isProfessional
              isStateUnchanged
              isValidGrayCard
              isKilometersUnChanged
              isValidVehicleInspection
              kilometersChanged
              validGrayCard
              validVehicleInspection
              stateUnchanged
            }
          }
        }`
      }
    },

    watch: {
      ownerInformation () {
        if (this.ownerInformation) {
          if (!this.ownerInformation.owners) {
            this.ownerInformation.owners = {
              owner: {
                firstName: '',
                lastName: '',
                usedName:'',
                companyName: '',
                siretNumber: '',
                address:{
                  address:'',
                  zipCode:'',
                  city:''

                },
                civility: ''
              },
              hasCoOwner: false,
              coOwner: {
                firstName: '',
                lastName: '',
                usedName:'',
                address:{
                  address:'',
                  zipCode:'',
                  city:''

                },
                civility: ''
              }
            }
          }
          if (!this.ownerInformation.ownerQuestions) {
            this.ownerInformation.ownerQuestions = {
              isKilometersUnChanged: true,
              isValidGrayCard: true,
              isValidVehicleInspection: true,
              isStateUnchanged: true
            }
          }
        }
      }
    },

    methods: {
      toggleBlock (step) {
        this.activeStep = step
      }
    },

    apollo: {
      ownerInformation: {
        query () {
          return this.ownerInformationQuery
        }
      }
    }
  }
</script>
